import { databaseRef } from 'config'

import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'
import { updateUser } from './updateUser.action'

export const completePayment = (
  onSuccess: () => void = () => {
    return
  }
) => (dispatch, getState) => {
  const userData = getState().user.data
  const { uid } = getState().user.auth
  const updates = {
    paid: true
  }
  dispatch(action(USER_ACTION_TYPES.payment_completion_begins))
  databaseRef
    .child('users')
    .child(uid)
    .update(updates)
  dispatch(action(USER_ACTION_TYPES.payment_completion_success))
  updateUser({ ...userData, ...updates })(dispatch, getState)
  onSuccess()
}



// WEBPACK FOOTER //
// ./src/store/user/actions/completePayment.action.ts